import React from 'react';
import { useTranslation } from 'react-i18next';
import DiamondBalance from './common/DiamondBalance';

export default function RewardsInfo() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <>
      <DiamondBalance />

      <div className="member-diamonds-conversion">
        <h4>{t('index_what_are_diamonds_')}</h4>
        <p>{t('index_what_are_diamonds_description')}</p>
      </div>
    </>
  );
}
